import Gigya, { BaseParams } from './gigya.js'
import GigyaResponse from './interfaces/gigya-response.js'

export type BootstrapParams = {}
export type BootstrapResponse = {
	authWorkspaces: {
		authWsId: string
		clientId: string
	}[]
}

export class AccountsB2bSetup {
	constructor(protected gigya: Gigya) {}

	public bootstrap(params: BaseParams & BootstrapParams) {
		return this.gigya.request<GigyaResponse & BootstrapResponse>(
			'accounts.b2b.setup.bootstrap',
			params
		)
	}
}
